export const SET_COUNSELOR_STUDENT_ID = 'SET_COUNSELOR_STUDENT_ID';
export const SET_COUNSELOR_STUDENT_SCHEDULE = 'SET_COUNSELOR_STUDENT_SCHEDULE';
export const SET_COUNSELOR_RETRIEVING_STUDENT_DATA =
  'SET_COUNSELOR_RETRIEVING_STUDENT_DATA';
export const GRAD_PLANS_POPULATE = 'GRAD_PLANS_POPULATE';
export const STUDENT_GRAD_PLAN_UPDATE = 'STUDENT_GRAD_PLAN_UPDATE';
export const GRAD_PLANS_SET_LOADING = 'GRAD_PLANS_SET_LOADING';
export const CAREER_PATHWAYS_POPULATE = 'CAREER_PATHWAYS_POPULATE';
export const STUDENT_CAREER_PATHWAY_UPDATE = 'STUDENT_CAREER_PATHWAY_UPDATE';
export const CAREER_PATHWAYS_SET_LOADING = 'CAREER_PATHWAYS_SET_LOADING';
export const EXCEPTION_NOTE_SET = 'EXCEPTION_NOTE_SET';
export const OVERRIDE_SUBMIT = 'OVERRIDE_SUBMIT';
export const UPDATE_PLAN_STATUS = 'UPDATE_PLAN_STATUS';
export const SET_PLAN_ACTIVITY = 'SET_PLAN_ACTIVITY';
export const SET_APPROVAL_STATUS = 'SET_APPROVAL_STATUS';
export const REMOVE_COURSE_OPTIMISTIC = 'REMOVE_COURSE_OPTIMISTIC';
export const SET_ACTIVE_TAB_SIDEBAR = 'SET_ACTIVE_TAB_SIDEBAR';
export const ADD_COURSE_OPTIMISTIC = 'ADD_COURSE_OPTIMISTIC';
